// extracted by mini-css-extract-plugin
export var container = "EditDetails-module--container--1+8nM";
export var content = "EditDetails-module--content--a1+uy";
export var footer = "EditDetails-module--footer--wdLwP";
export var input = "EditDetails-module--input--gX8g1";
export var title = "EditDetails-module--title--JV+5e";